import { useEditorStore } from '@/features/editor/stores/mobx/editor-store';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { SelectField } from '@/components/select-field';
import { ESDEC_ZONES_BY_COUNTRY } from '../esdec-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icons } from '@/assets';
import { EsdecWeatherZonesPlaceholder } from './esdec-weather-zones-card';

export const EsdecTerrainTypeInput = observer(function EsdecTerrainTypeInput({
  surfaceId
}: {
  surfaceId: string;
}) {
  const store = useEditorStore();
  const intl = useIntl();
  const { surfacesEsdec } = store;

  const surfaceEsdec = surfacesEsdec.surfaces[surfaceId];

  if (!surfaceEsdec) {
    return <React.Fragment />;
  }

  const terrainCategoryOptions = ESDEC_ZONES_BY_COUNTRY.sweden.terrainCategory.map((terrainCategory) => ({
    label: terrainCategory,
    value: terrainCategory
  }));

  return (
    <SelectField
      isDisabled={surfaceEsdec.isRoofFinalized}
      label={intl.formatMessage({
        defaultMessage: 'Terrain Type',
        id: 'wXn2ju'
      })}
      placeholder={
        <EsdecWeatherZonesPlaceholder
          icon={<Icons.Terrain />}
          text={<FormattedMessage defaultMessage="Select Terrain Category" id="fJZkfv" />}
        />
      }
      name="terrainCategory"
      options={terrainCategoryOptions}
      onChange={(value) => {
        if (value) {
          surfaceEsdec.updateTerrainCategory(value.value);
        }
      }}
      value={terrainCategoryOptions.find(
        (terrainCategoryOption) => terrainCategoryOption.value === surfaceEsdec.terrainCategory
      )}
    />
  );
});
